import styled from "styled-components";
import { colors } from "../../../../../../theme/theme";
import { Button } from "react-bootstrap";

export const InvoiceWrapper = styled.div`
	width: 100%;

	button {
		padding: 8px 16px;
		line-height: 1;
	}

	input {
		display: none;
	}

	.has-invoice {
		width: 100%;

		color: ${colors.mainColors.blueberry};
		display: flex;
		align-items: center;
		justify-content: space-between;

		a,
		a:visited {
			color: ${colors.mainColors.blueberry};
			font-size: 16px;
			line-height: 1;
		}

		em {
			color: ${colors.alertColors.danger_red};
		}
	}
`;


export const ButtonStyled = styled(Button)`
	&.form-error{
		border: 1px solid ${colors.alertColors.danger_red};
		color: ${colors.alertColors.danger_red};
	}
`
